import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutView = () => {
    const { t } = useTranslation();
    const styles = {
        container: { padding: '30px', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' },
        title: { borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '20px' },
        section: { marginBottom: '30px' }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>{t('about_title')}</h2>

            <div style={styles.section}>
                <p>
                    {t('about_intro')}
                </p>
            </div>

            <div style={styles.section}>
                <h4>{t('about_vision')}</h4><p>{t('about_vision_text')}</p>
            </div>

            <div style={styles.section}>
                <h4>{t('about_commitment')}</h4><p>{t('about_commitment_text')}</p>
            </div>
        </div>
    );
};

export default AboutView;
